<!--@format-->
<template>
    <div class="solution-preview-popup">
        <close-svg class="close-btn" @click.native="closePopup" />
        <div class="solution">
            <div class="solution-preview-image">
                <div
                    v-if="solutionDetails.previewImageUrl"
                    class="preview-image"
                    :style="{ 'background-image': `url('${solutionDetails.previewImageUrl}')` }"
                ></div>
                <app-file-icon v-else class="svg-container" type="image" />
            </div>
            <div class="solution-details">
                <div>
                    <p><strong>Solution Name:</strong> {{ solutionDetails.name }}</p>
                    <p><strong>Category:</strong> {{ solutionDetails.category }}</p>
                    <p><strong>SKU:</strong> {{ solutionDetails.sku }}</p>
                </div>
                <div>
                    <p>
                        <strong>Created on:</strong>
                        {{ solutionDetails.createdAt | momentDateMMMDoYYYY }}
                    </p>
                    <p>
                        <strong>Last update:</strong>
                        {{ solutionDetails.updatedAt | momentDateMMMDoYYYY }}
                    </p>
                </div>
            </div>
            <div class="solution-description">
                <div v-if="solutionDetails.description" class="description-container">
                    <p>{{ solutionDetails.description }}</p>
                </div>
                <p v-else>No Description</p>
            </div>
            <div v-if="isOwner" class="actions-container">
                <app-button class="action transparent-button" @click="openSolutionEditWidget">
                    Edit
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const AppFileIcon = () => import('@/components/common/app-file-icon');
const CloseSvg = () => import('@/components/svg/close-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    components: {
        'app-button': AppButton,
        'close-svg': CloseSvg,
        'app-file-icon': AppFileIcon,
    },

    props: {
        accountId: {
            type: Number,
            required: true,
        },

        solution: {
            type: Object,
            required: true,
        },
    },

    computed: {
        solutionDetails() {
            return this.solution;
        },

        isOwner() {
            return this.solutionDetails.accountId === this.accountId;
        },
    },

    methods: {
        openSolutionEditWidget() {
            EventBus.$emit('open-widget', {
                name: 'solution-widget',
                solutionId: this.solutionDetails.id,
                accountId: this.solutionDetails.accountId,
                action: 'Edit',
            });

            this.closePopup();
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.solution-preview-popup {
    max-width: 803px;
    width: 100%;
    color: #ffffff;
    height: 100%;
    padding: 70px 20px 40px 20px;
    position: static;
    overflow: auto;
}

.solution-preview-popup .solution-preview-image {
    width: 100%;
    height: 400px;
    margin-bottom: 18px;
    display: flex;
}

.solution-preview-popup .solution-preview-image .preview-image {
    height: 100%;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 6px;
}

.solution-preview-popup .solution-preview-image .svg-container {
    text-align: center;
    width: 100%;
}

.solution-preview-popup .solution-preview-image .svg-container svg {
    height: 400px;
    width: auto;
}

.solution-preview-popup .solution-details {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;
}

.solution-preview-popup p strong {
    color: #ffffff;
}

.solution-preview-popup .solution-details div {
    display: flex;
    flex-direction: column;
    padding-right: 10px;
}

.solution-preview-popup .solution-description {
    padding-bottom: 20px;
    border-bottom: 1px solid #ffffff;
}

.solution-preview-popup .solution-description .description-container {
    display: flex;
    flex-wrap: wrap;
}

.solution-preview-popup .actions-container {
    padding: 10px 0px;
    display: flex;
    justify-content: flex-end;
}

.solution-preview-popup .actions-container .action {
    margin-left: 15px;
}

.solution-preview-popup .actions-container .transparent-button {
    border: 2px solid #ffffff;
    background: transparent;
}
</style>
